<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户名" :value="2"></el-option>
                            <el-option label="负责人手机" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.provinceCode" placeholder="请选择省份" clearable filterable size="small" @change="getCityList">
                        <el-option v-for="(item,index) in province" :key="index" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.cityCode" placeholder="请选择城市" clearable filterable size="small">
                        <el-option v-for="(item,index) in city" :key="index" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.order" placeholder="请选择" size="small">
                        <el-option label="优先展示最新注册的" :value="1"></el-option>
                        <el-option label="优先展示最近登录的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="注册时间" :value="1"></el-option>
                                <el-option label="最近登录时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/performer/save')" type="primary" icon="el-icon-plus" size="small" @click="$refs.artistAdd.show()">创建艺人</el-button>
            <el-button type="success" icon="el-icon-upload2" size="small" @click="$refs.neteaseIdMatch.show()">云音乐艺人id匹配</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="status" label="账号状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success" size="mini">正常</el-tag>
                        <el-tag v-else type="info" size="mini">注销</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column label="用户名" min-width="120">
                    <template slot-scope="scope">
                        <el-tooltip placement="top">
                            <div slot="content" class="avatar">
                                <el-image v-if="scope.row.avatar" :src="scope.row.avatar"></el-image>
                                <p>{{scope.row.name}}</p>
                            </div>
                            <div class="ellipsis">{{scope.row.name}}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="telephone" label="负责人手机" min-width="110">
                    <template slot-scope="scope">
                        {{scope.row.telephone && scope.row.telephone.includes('tmp') ? '' : scope.row.telephone}}
                    </template>
                </el-table-column>
                <el-table-column prop="provinceName" label="省份"></el-table-column>
                <el-table-column prop="cityName" label="城市"></el-table-column>
                <el-table-column prop="registTime" label="注册时间" min-width="150"></el-table-column>
                <el-table-column prop="lastLoginTime" label="最近登录时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="220">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/performer/detail')"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="edit(scope.row.id)"
                            >管理</el-button
                        >
                        <el-button
                            v-if="$utils.have('/userPunish/search') && scope.row.status == 1"
                            type="text"
                            size="small"
                            icon="el-icon-remove-outline"
                            @click="del(scope.row.id)"
                            >注销</el-button
                        >
                        <el-link
                            v-if="scope.row.status == 1"
                            type="primary"
                            size="small"
                            icon="el-icon-link"
                            :href="`${ssfb}/login/auto?id=${scope.row.encryptId}&token=${$store.state.CUSUT}`"
                            target="_blank"
                            >进入经营平台</el-link
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>        
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <artist-add ref="artistAdd" @onUpdate="getDataList()"></artist-add>
        <netease-id-match ref="neteaseIdMatch" @onUpdate="getDataList()"></netease-id-match>
    </div>
</template>

<script>
import {fetchProvince,fetchCityList} from '@/assets/js/commonApi'
import ArtistAdd from '@/components/ArtistAdd';
import NeteaseIdMatch from './components/neteaseIdMatch.vue';
const defaultParams = {
    pageNo:1,
    type: 2,
    value: '',
    timeType:1,
    startTime:'',
    endTime:'',
    provinceCode:'',
    cityCode: '',
    order: 1
}
export default {
    components:{ArtistAdd, NeteaseIdMatch},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                type: parseInt(this.$route.query.type || 2),
                value: this.$route.query.value || '',
                timeType:parseInt(this.$route.query.timeType || 1),
                startTime:this.$route.query.startTime || '',
                endTime:this.$route.query.endTime || '',
                provinceCode: this.$route.query.provinceCode ? parseInt(this.$route.query.provinceCode) : '',
                cityCode: parseInt(this.$route.query.cityCode) || '',
                order: parseInt(this.$route.query.order || 1)
            },
            listLoading: false,    
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            province:[],
            city:[],
            ssfb:process.env.VUE_APP_SSFB_URL
        }
    },
    created(){
        this.getProvince();
        if( this.params.provinceCode ){
            this.getCityList(this.params.cityCode);
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取所有省份
        async getProvince(){
            const res = await fetchProvince({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.province = result;
            }
        },
        //获取城市
        async getCityList(cityCode){
            const res = await fetchCityList(this.params.provinceCode).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.city = result;
            }
            this.params.cityCode = cityCode || '';
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/performer/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //注销
        del(id){
            this.$confirm('小站注销后前端不会展示,但是不影响用户购买的订单', '提示', {
                type: 'warning',
                center: true,
                confirmButtonText:'前往注销',
                cancelButtonText:'暂不注销',
                closeOnClickModal: false
            }).then(() => {
                this.$router.push({
                    path:'/user/punish/list',
                    query:{id:id}
                })
            }).catch(() => {})
        },
        //编辑、查看详情
        edit(id){
            this.$router.push({
                path: `/user/artist/edit/baseInfo/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        }
    }
}
</script>


<style lang="scss" scoped>
.el-table{
    .el-link{
        font-size: 12px;
        margin-left:10px;
    }
}
.avatar{
    text-align: center;
    .el-image{
        width: 100px;
        margin-bottom: 10px;
    }
}

</style>